import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loadingSubject.asObservable();

  show() {
    this.setLoading(true);
  }

  hide() {
    this.setLoading(false);
  }

  private setLoading(isLoading: boolean) {
    Promise.resolve().then(() => this.loadingSubject.next(isLoading));
  }
}
